import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";

import { requestResetPasswordAction } from "../../actions/authActions";
import { clearServerErrors } from "../../actions/errors";

const RequestResetPassword = ({
  requestResetPasswordAction,
  serverErrors,
  clearServerErrors,
}) => {
  const { t } = useTranslation();
  const RequestResetPasswordSchema = yup.object().shape({
    email: yup.string().email().required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(RequestResetPasswordSchema),
  });

  useEffect(() => {
    clearServerErrors();
  }, []);

  return (
    <div className="parent-container-short">
      <div className="recover-password">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <g id="SVGRepo_bgCarrier" strokeWidth={0} />
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="SVGRepo_iconCarrier">
            <path
              style={{
                fill: "#f4f4f4",
              }}
              d="M485.517,308.966H26.483C11.857,308.966,0,297.109,0,282.483V176.552 c0-14.626,11.857-26.483,26.483-26.483h459.034c14.626,0,26.483,11.857,26.483,26.483v105.931 C512,297.109,500.143,308.966,485.517,308.966z"
            />
            <path
              style={{
                fill: "#e6e6e6",
              }}
              d="M503.172,229.517c0-38.941-31.68-70.621-70.621-70.621s-70.621,31.68-70.621,70.621v20.89 c-5.594,6.358-8.828,14.611-8.828,23.247v26.483c0,2.987,0.197,5.926,0.521,8.828h131.893c14.626,0,26.483-11.857,26.483-26.483 v-8.828c0-8.637-3.233-16.891-8.828-23.247V229.517z"
            />
            <g>
              <path
                style={{
                  fill: "#464655",
                }}
                d="M241.259,207.448c-2.44-4.233-7.853-5.673-12.061-3.233l-17.336,10.01v-20.019 c0-4.879-3.948-8.828-8.828-8.828s-8.828,3.948-8.828,8.828v20.019l-17.336-10.009c-4.224-2.44-9.621-1-12.061,3.233 c-2.44,4.224-0.991,9.621,3.233,12.061l17.334,10.008l-17.334,10.008c-4.224,2.44-5.673,7.837-3.233,12.061 c1.638,2.836,4.604,4.414,7.656,4.414c1.5,0,3.017-0.38,4.405-1.181l17.336-10.012v20.019c0,4.879,3.948,8.828,8.828,8.828 s8.828-3.948,8.828-8.828v-20.019l17.336,10.009c1.388,0.802,2.905,1.181,4.405,1.181c3.052,0,6.017-1.578,7.656-4.414 c2.44-4.224,0.991-9.621-3.233-12.061l-17.334-10.007l17.334-10.008C242.25,217.069,243.699,211.672,241.259,207.448z"
              />
              <path
                style={{
                  fill: "#464655",
                }}
                d="M135.328,207.448c-2.449-4.233-7.853-5.673-12.061-3.233l-17.336,10.01v-20.019 c0-4.879-3.948-8.828-8.828-8.828c-4.879,0-8.828,3.948-8.828,8.828v20.019L70.94,204.216c-4.224-2.44-9.612-1-12.061,3.233 c-2.44,4.224-0.991,9.621,3.233,12.061l17.334,10.007l-17.334,10.008c-4.224,2.44-5.673,7.837-3.233,12.061 c1.638,2.836,4.604,4.414,7.656,4.414c1.5,0,3.017-0.38,4.405-1.181l17.336-10.01v20.019c0,4.879,3.948,8.828,8.828,8.828 c4.879,0,8.828-3.948,8.828-8.828v-20.019l17.336,10.009c1.388,0.802,2.905,1.181,4.405,1.181c3.052,0,6.017-1.578,7.656-4.414 c2.44-4.224,0.991-9.621-3.233-12.061l-17.334-10.007l17.334-10.008C136.319,217.069,137.768,211.672,135.328,207.448z"
              />
              <path
                style={{
                  fill: "#464655",
                }}
                d="M343.957,239.526l-17.334-10.008l17.334-10.008c4.224-2.44,5.673-7.837,3.233-12.061 c-2.449-4.233-7.853-5.673-12.061-3.233l-17.336,10.01v-20.019c0-4.879-3.948-8.828-8.828-8.828s-8.828,3.948-8.828,8.828v20.019 l-17.336-10.009c-4.215-2.44-9.621-1-12.061,3.233c-2.44,4.224-0.991,9.621,3.233,12.061l17.334,10.008l-17.334,10.008 c-4.224,2.44-5.673,7.837-3.233,12.061c1.638,2.836,4.604,4.414,7.656,4.414c1.5,0,3.017-0.38,4.405-1.181l17.336-10.012v20.019 c0,4.879,3.948,8.828,8.828,8.828s8.828-3.948,8.828-8.828v-20.019l17.336,10.009c1.388,0.802,2.905,1.181,4.405,1.181 c3.052,0,6.017-1.578,7.656-4.414C349.63,247.362,348.181,241.965,343.957,239.526z"
              />
            </g>
            <path
              style={{
                fill: "#5B5D6E",
              }}
              d="M432.552,176.552c-29.207,0-52.966,23.758-52.966,52.966v35.31h17.655v-35.31 c0-19.474,15.837-35.31,35.31-35.31s35.31,15.837,35.31,35.31v35.31h17.655v-35.31C485.517,200.31,461.759,176.552,432.552,176.552z "
            />
            <path
              style={{
                fill: "#ff6500",
              }}
              d="M432.552,361.931L432.552,361.931c34.127,0,61.793-27.666,61.793-61.793v-26.483 c0-9.751-7.904-17.655-17.655-17.655h-88.276c-9.751,0-17.655,7.904-17.655,17.655v26.483 C370.759,334.265,398.424,361.931,432.552,361.931z"
            />
            <path
              style={{
                fill: "#464655",
              }}
              d="M445.793,300.138c0-7.313-5.929-13.241-13.241-13.241s-13.241,5.929-13.241,13.241 c0,3.906,1.724,7.381,4.414,9.805v10.884c0,4.879,3.948,8.828,8.828,8.828c4.879,0,8.828-3.948,8.828-8.828v-10.884 C444.069,307.519,445.793,304.044,445.793,300.138z"
            />
            <path
              style={{
                fill: "#e05a00",
              }}
              d="M397.241,300.138v-26.483c0-9.751,7.905-17.655,17.655-17.655h-26.483 c-9.75,0-17.655,7.904-17.655,17.655v26.483c0,34.127,27.666,61.793,61.793,61.793c4.549,0,8.971-0.525,13.241-1.458 C418.036,354.407,397.241,329.716,397.241,300.138z"
            />
          </g>
        </svg>
        <p className="recover-password-title">{t("recover password")}</p>
        {/* <p className="has-text-centered">{t("reset_password_page_hint")}</p> */}
        <form
          onSubmit={handleSubmit(requestResetPasswordAction)}
          noValidate
          autoComplete="off"
        >
          <input
            className="input"
            placeholder={t("Enter your email")}
            {...register("email")}
          />
          {errors.email && (
            <p className="help is-danger error-text">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                <path d="M512 64a448 448 0 110 896 448 448 0 010-896zm0 832a384 384 0 000-768 384 384 0 000 768zm48-176a48 48 0 11-96 0 48 48 0 0196 0zm-48-464a32 32 0 0132 32v288a32 32 0 01-64 0V288a32 32 0 0132-32z"></path>
              </svg>
              {t(errors.email?.message.key)}
            </p>
          )}
          {serverErrors.error && (
            <p className="help is-danger error-text">{t(serverErrors.error)}</p>
          )}

          <div className="check-code">
            <img src="../../img/code.png" alt="" />
            <input type="text" placeholder={t("code")} />
          </div>

          <button type="submit">{t("confirm")}</button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    serverErrors: state.errors.errors,
  };
};

export default connect(mapStateToProps, {
  requestResetPasswordAction,
  clearServerErrors,
})(RequestResetPassword);
